import { Radio } from "@mui/material";
import React from "react";
import { Address } from "../../../types/userTypes";

interface AddressCardProps {
  value: string;
  selectedValue: string;
  handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  item: Address;
}

const AddressCard: React.FC<AddressCardProps> = ({
  value,
  selectedValue,
  handleChange,
  item,
}) => {
  const isSelected = value === selectedValue;

  return (
    <div
      onClick={() =>
        handleChange({
          target: { value },
        } as React.ChangeEvent<HTMLInputElement>)
      }
      className={`p-5 border rounded-md flex cursor-pointer transition ${
        isSelected ? "border-black bg-gray-50" : "border-gray-200"
      }`}
    >
      <div>
        <Radio
          checked={isSelected}
          onChange={handleChange}
          value={value}
          name="checkout-address"
          inputProps={{ "aria-label": item.name }}
        />
      </div>

      <div className="space-y-3 pt-3">
        <div className="flex items-center gap-2">
          <h1 className="font-semibold">{item.name}</h1>

          {item.defaultAddress && (
            <span className="text-[10px] px-2 py-0.5 rounded-full bg-gray-200 text-gray-700">
              Default
            </span>
          )}
        </div>

        <p className="w-full sm:w-[320px] text-sm text-gray-700">
          {item.address}
          {item.locality ? `, ${item.locality}` : ""}
          {item.city ? `, ${item.city}` : ""}
          {item.state ? `, ${item.state}` : ""} - {item.pinCode}
        </p>

        <p className="text-sm">
          <strong>Mobile : </strong> {item.mobile}
        </p>
      </div>
    </div>
  );
};

export default AddressCard;